import { useIsInternalAdmin } from '@/hooks/useIsInternalAdmin';
import { Loader2 } from 'lucide-react';

interface InternalAdminRouteProps {
  children: React.ReactNode;
}

export const InternalAdminRoute = ({ children }: InternalAdminRouteProps) => {
  const { data: isAdmin, isLoading } = useIsInternalAdmin();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center p-8">
        <h1 className="text-2xl font-bold mb-2">403 — Access Denied</h1>
        <p className="text-muted-foreground">This page is restricted to internal administrators.</p>
      </div>
    );
  }

  return <>{children}</>;
};
